function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getSharedCellStyles } from '../_TableCell/_TableCell.theme';
export var tableHeaderCellTheme = {
  baseStyle: _ref => {
    var {
      isClickable,
      textAlign
    } = _ref;
    return _objectSpread(_objectSpread({}, getSharedCellStyles(isClickable, textAlign)), {}, {
      color: 'neutral.black',
      textStyle: 'body4Semi',
      alignItems: 'flex-start',
      '&[data-component="TableSelectableCell"]': {
        padding: 'xs',
        alignItems: 'center'
      }
    });
  },
  variants: {
    light: {},
    dark: _ref2 => {
      var {
        isClickable
      } = _ref2;
      return {
        color: 'neutral.darkest',
        _hover: {
          backgroundColor: isClickable ? 'neutral.lighter' : 'initial'
        },
        '&[data-selected="true"]': {
          color: 'neutral.black'
        },
        _active: {
          backgroundColor: isClickable ? 'neutral.light' : 'initial'
        }
      };
    }
  },
  defaultProps: {
    textAlign: 'start'
  }
};
//# sourceMappingURL=_TableHeaderCell.theme.js.map